/* Модуль модального окна лидогенерации и регистрации */
function createModalDOM() {
    if (document.getElementById('metaOnboardBackdrop')) return;

    const tg = window.Telegram?.WebApp;
    const isInsideTelegram = !!(tg && tg.initData && tg.initData.length > 0);
    const tgUser = isInsideTelegram ? tg.initDataUnsafe?.user : null;
    const hasTgContactBtn = isInsideTelegram && typeof tg.requestContact === 'function';

    const modalHTML = `
      <div class="meta-onboard-backdrop" id="metaOnboardBackdrop">
        <div class="meta-onboard-card" role="dialog" aria-modal="true">
          <button type="button" class="meta-onboard-close" id="metaOnboardCloseBtn" aria-label="Закрыть">✕</button>

          <div style="text-align: center; margin-bottom: 14px;">
            <div class="meta-onboard-badge">✦ БЕСПЛАТНЫЙ БИЛЕТ</div>
            <h2 class="meta-onboard-title" style="font-size: 20px; margin-top: 6px; margin-bottom: 4px;">Куда открыть доступ к 1-й лекции?</h2>
            <p class="meta-onboard-subtitle" style="font-size: 13.5px; color: #5C5857;">Введите номер телефона. Видео откроется сразу, платить ничего не нужно:</p>
          </div>

          <div class="meta-free-banner" style="margin-bottom: 14px; background: rgba(34, 169, 107, 0.10); border: 1px solid rgba(34, 169, 107, 0.35); border-radius: 12px; padding: 10px 12px; text-align: left;">
            <div class="meta-free-banner-title" style="font-size: 13px; font-weight: 700; color: #1A8754;">🎁 Бесплатный доступ ко всем 4 лекциям</div>
            <div class="meta-free-banner-sub" style="font-size: 12px; color: #5C5857; margin-top: 2px;">Записи 4 подробных лекций по 1-1.5 часа сохранятся в вашем личном кабинете.</div>
          </div>

          <div id="metaOnboardErrorMsg" style="display: none; background: #FEF2F2; border: 1px solid #FCA5A5; color: #B91C1C; border-radius: 10px; padding: 8px 12px; font-size: 12px; margin-bottom: 12px; text-align: center; font-weight: 500;"></div>

          <form class="meta-onboard-form" id="metaOnboardForm" novalidate>
            <!-- Honeypot антибот-ловушка (невидимо для человека) -->
            <div style="opacity: 0; position: absolute; top: 0; left: 0; height: 0; width: 0; z-index: -1; overflow: hidden; pointer-events: none;" aria-hidden="true" tabindex="-1">
              <input type="text" name="website_url" id="metaOnboardWebsiteUrl" tabindex="-1" autocomplete="off" value="">
            </div>

            <div class="meta-onboard-group">
              <label class="meta-onboard-label" for="metaOnboardPhone">Номер телефона *</label>
              <div class="meta-onboard-input-wrap">
                <span class="meta-onboard-icon">📱</span>
                <input type="tel" class="meta-onboard-input" id="metaOnboardPhone" placeholder="+7 (999) 000-00-00" required inputmode="tel" autocomplete="tel">
              </div>
              ${hasTgContactBtn ? `
                <button type="button" class="meta-tg-contact-btn" id="metaTgContactBtn" style="margin-top: 6px;">
                  <span>📲</span> Поделиться номером из Telegram
                </button>
              ` : ''}
            </div>

            <div class="meta-onboard-group">
              <label class="meta-onboard-label" for="metaOnboardEmail">Ваш Email *</label>
              <div class="meta-onboard-input-wrap">
                <span class="meta-onboard-icon">✉️</span>
                <input type="email" class="meta-onboard-input" id="metaOnboardEmail" placeholder="name@example.com" required inputmode="email" autocomplete="email" autocapitalize="none" autocorrect="off" spellcheck="false">
              </div>
              <div style="font-size: 11px; color: #7A7571; margin-top: 4px; line-height: 1.35;">
                Для отправки ссылки на доступ и материалов интенсива.
              </div>
            </div>

            <div class="badge-security-3words" style="margin: 10px auto 6px;">
              <span>🛡️ Данные надежно защищены</span>
            </div>

            <button type="submit" class="meta-onboard-btn-submit" id="metaOnboardSubmitBtn" style="margin-top: 8px;">
              <span id="metaOnboardBtnText">👉 Открыть 1-ю лекцию сейчас</span>
            </button>

            <p class="meta-onboard-legal" style="margin-top: 10px; font-size: 10.5px; text-align: center; color: #8A8580;">
              Нажимая кнопку, вы соглашаетесь с 
              <a href="/legal.html" target="_blank" style="color: #1A8754; text-decoration: underline;">Политикой конфиденциальности</a>.
            </p>
          </form>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const formEl = document.getElementById('metaOnboardForm');
    if (formEl) {
      formEl.addEventListener('submit', (ev) => {
        ev.preventDefault();
        handleFormSubmit(ev);
      });
    }

    const closeBtn = document.getElementById('metaOnboardCloseBtn');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    const backdrop = document.getElementById('metaOnboardBackdrop');
    if (backdrop) {
      backdrop.addEventListener('click', (e) => {
        if (e.target === backdrop) {
          if (document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA')) {
            document.activeElement.blur();
            return;
          }
          closeModal();
        }
      });
    }

    const contactBtn = document.getElementById('metaTgContactBtn');
    if (contactBtn && tg) {
      contactBtn.addEventListener('click', () => {
        try {
          tg.requestContact((granted, response) => {
            if (granted && response?.responseUnsafe?.contact?.phone_number) {
              const phone = response.responseUnsafe.contact.phone_number;
              const formattedPhone = phone.startsWith('+') ? phone : `+${phone}`;
              const phoneInput = document.getElementById('metaOnboardPhone');
              if (phoneInput) {
                phoneInput.value = formattedPhone;
              }
            }
          });
        } catch (e) {
          console.warn('requestContact error:', e);
        }
      });
    }
  }

  // Время открытия модального окна для защиты от ботов (time-trap)
  let modalOpenedAt = 0;

  // Показ модалки входа
  function openModal(redirectAfter = null) {
    createModalDOM();
    modalOpenedAt = Date.now();
    const backdrop = document.getElementById('metaOnboardBackdrop');
    if (backdrop) {
      if (redirectAfter) {
        backdrop.dataset.redirect = redirectAfter;
      }
      backdrop.classList.add('is-open');
    }
    onModalStateChanged();
  }

  // Скрытие модалки
  function closeModal() {
    isFormSubmitting = false;
    const backdrop = document.getElementById('metaOnboardBackdrop');
    if (backdrop) {
      backdrop.classList.remove('is-open');
    }
    try { sessionStorage.setItem('meta_reg_modal_dismissed', 'true'); } catch (e) {}
    onModalStateChanged();
    const currentPath = window.location.pathname;
    const isProtectedLesson = currentPath.includes('day-1') || currentPath.includes('day-2') || currentPath.includes('day-3') || currentPath.includes('day-4');
    const isProtectedArea = isProtectedLesson || currentPath.includes('dashboard') || currentPath.includes('questionnaire') || currentPath.includes('referral') || currentPath.includes('course-tariffs');
    if (isProtectedArea && (typeof isRegistered === 'function' && !isRegistered())) {
      window.location.href = '/' + (window.location.search || '');
    }
  }

  // Флаг защиты от повторной одновременной отправки формы
  let isFormSubmitting = false;

  // Отправка формы регистрации
  async function handleFormSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (isFormSubmitting) {
      return false;
    }
    isFormSubmitting = true;

    triggerHaptic('medium');

    const phoneInput = document.getElementById('metaOnboardPhone');
    const emailInput = document.getElementById('metaOnboardEmail');
    const submitBtn = document.getElementById('metaOnboardSubmitBtn');
    const btnText = document.getElementById('metaOnboardBtnText');
    const errorMsgEl = document.getElementById('metaOnboardErrorMsg');

    function showError(msg, focusInput) {
      isFormSubmitting = false;
      if (submitBtn) submitBtn.disabled = false;
      if (btnText) btnText.innerHTML = '👉 Открыть 1-ю лекцию сейчас';
      if (errorMsgEl) {
        errorMsgEl.textContent = msg;
        errorMsgEl.style.display = 'block';
      }
      if (focusInput) {
        focusInput.focus();
        focusInput.style.borderColor = '#EF4444';
      }
    }

    if (errorMsgEl) errorMsgEl.style.display = 'none';
    if (phoneInput) phoneInput.style.borderColor = '';
    if (emailInput) emailInput.style.borderColor = '';

    const phone = phoneInput ? phoneInput.value.trim() : '';
    const email = emailInput ? emailInput.value.trim().toLowerCase() : '';

    if (phoneInput) phoneInput.value = phone;
    if (emailInput) emailInput.value = email;

    const cleanPhone = phone.replace(/\D/g, '');
    if (!phone || cleanPhone.length < 10 || cleanPhone.length > 15) {
      showError('Пожалуйста, укажите корректный номер телефона (от 10 до 15 цифр)', phoneInput);
      return;
    }

    // Запрет горячих линий и корпоративных сервисных номеров (800, 804, 808, 809 независимо от префикса 7/8 или длины)
    const tollFreePrefixes = ['800', '804', '808', '809', '7800', '7804', '7808', '7809', '8800', '8804', '8808', '8809'];
    if (tollFreePrefixes.some(p => cleanPhone.startsWith(p))) {
      showError('Регистрация с номеров горячих линий 8-800 недоступна. Пожалуйста, укажите личный мобильный номер (+7 9XX...)', phoneInput);
      return;
    }

    // Для номеров РФ/РК (полный 11-значный формат с 7 или 8): мобильный код оператора обязан начинаться на 9 (РФ) или 7 (РК)
    if (cleanPhone.length === 11 && (cleanPhone.startsWith('7') || cleanPhone.startsWith('8'))) {
      if (!['9', '7'].includes(cleanPhone[1])) {
        showError('Пожалуйста, укажите действующий мобильный номер телефона (+7 9XX...)', phoneInput);
        return;
      }
    } else if (cleanPhone.length === 10) {
      // 10 цифр (ввод без префикса страны): первая цифра обязана быть 9 (РФ) или 7 (РК)
      if (!['9', '7'].includes(cleanPhone[0])) {
        showError('Пожалуйста, укажите действующий мобильный номер телефона (+7 9XX...)', phoneInput);
        return;
      }
    } else if (cleanPhone.startsWith('7') || cleanPhone.startsWith('8')) {
      // Номер РФ/РК с префиксом 7 или 8 обязан содержать ровно 11 цифр
      showError('Номер телефона РФ/РК должен содержать ровно 11 цифр (+7 9XX XXX-XX-XX)', phoneInput);
      return;
    }

    // Проверка на фиктивные номера из одинаковых цифр или последовательностей (например, +7 999 999-99-99, 123456789)
    const lastDigits = cleanPhone.slice(-9);
    if (new Set(lastDigits).size <= 1 || lastDigits === '123456789' || lastDigits === '987654321') {
      showError('Пожалуйста, укажите действующий личный мобильный номер телефона', phoneInput);
      return;
    }

    if (!email || !email.includes('@') || !email.includes('.')) {
      showError('Пожалуйста, укажите корректный адрес электронной почты (Email)', emailInput);
      return;
    }

    const emailDomain = email.split('@')[1] ? email.split('@')[1].toLowerCase().trim() : '';
    const disposableDomains = [
      'tempmail.com', 'temp-mail.org', '10minutemail.com', 'guerrillamail.com',
      'mailinator.com', 'trashmail.com', 'yopmail.com', 'dropmail.me', 'dispostable.com',
      'tempail.com', 'fakeinbox.com', 'sharklasers.com', 'getairmail.com'
    ];
    if (disposableDomains.some(d => emailDomain === d || emailDomain.endsWith('.' + d)) || email === 'test@test.ru' || email === 'asdf@asdf.com' || email === 'admin@mail.ru') {
      showError('Пожалуйста, укажите действующий личный email для получения материалов', emailInput);
      return;
    }

    const tg = window.Telegram?.WebApp;
    const isInsideTelegram = !!(tg && tg.initData && tg.initData.length > 0);
    const tgUser = isInsideTelegram ? tg.initDataUnsafe?.user : null;

    let tgUsername = tgUser?.username ? `@${tgUser.username}` : '';

    let userName = tgUser ? [tgUser.first_name, tgUser.last_name].filter(Boolean).join(' ') : '';
    if (!userName && tgUsername) {
      userName = tgUsername.replace(/^@/, '');
    }
    if (!userName) {
      userName = 'Участник';
    }

    if (submitBtn) submitBtn.disabled = true;
    if (btnText) btnText.innerHTML = '<span class="meta-spinner"></span> Сохраняем доступ...';

    // Запрашиваем разрешение на отправку сообщений ТОЛЬКО если пользователь внутри Telegram WebApp
    if (!isRegistered() && isInsideTelegram) {
      try {
        await requestBotWriteAccess();
      } catch (e) {
        console.warn('requestBotWriteAccess error during submit:', e);
      }
    }

    const src = getSourceParam();
    let referrerId = '';
    if (src.startsWith('ref_')) {
      referrerId = src.replace('ref_', '').split('_')[0] || '';
    }

    const isPaidSource = src.includes('paid_all') || localStorage.getItem('meta_paid_all_days') === 'true';

    const isWebUser = !(tgUser?.id);
    const userPlatform = isWebUser ? 'web' : 'telegram';

    // Проверка honeypot и времени заполнения формы (time-trap)
    const honeypotInput = document.getElementById('metaOnboardWebsiteUrl');
    const honeypotVal = honeypotInput ? honeypotInput.value.trim() : '';
    const fillDurationMs = modalOpenedAt > 0 ? (Date.now() - modalOpenedAt) : 0;

    const payload = {
      action: 'registration',
      platform: userPlatform,
      telegramId: tgUser?.id ? String(tgUser.id) : '',
      name: userName,
      username: tgUsername || (tgUser?.username ? `@${tgUser.username}` : ''),
      telegram_username: tgUsername || (tgUser?.username ? `@${tgUser.username}` : ''),
      phone: phone,
      email: email,
      source: src,
      referrerId: referrerId,
      bonus: 0,
      has_paid: isPaidSource,
      honeypot: honeypotVal,
      website_url: honeypotVal,
      fill_duration_ms: fillDurationMs,
      createdAt: new Date().toISOString()
    };

    // 1. Сохраняем профиль локально
    const userProfile = {
      ...payload,
      bonusBalance: 0,
      registeredAt: new Date().toISOString(),
      registered: true
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(userProfile));
      localStorage.setItem(REGISTERED_FLAG, 'true');
      localStorage.setItem('meta_user_platform', userPlatform);
    } catch (err) {
      console.warn('localStorage error', err);
    }

    // 2. Отправляем в API / базу данных
    let regResult = null;
    try {
      regResult = await sendToGoogleSheet(payload);
    } catch (e) {
      console.warn('[MetaOnboarding] Background sheet save:', e);
    }

    const createdUserId = regResult?.userId || regResult?.user?.id || (typeof getUser === 'function' ? getUser()?.id : null);
    if (createdUserId && typeof setSessionCookie === 'function') {
      setSessionCookie('meta_user_id', createdUserId);
      setSessionCookie('meta_user_registered', 'true');
    }

    // 3. Отправляем цель в Яндекс.Метрику
    if (typeof trackGoal === 'function') {
      trackGoal('lead_register', {
        platform: userPlatform,
        has_phone: !!phone,
        has_email: !!email
      });
    }

    updateBonusUI();
    updateHeaderNav();
    updateLandingCTA();
    updateReferralUI();

    triggerHaptic('success');
    if (btnText) btnText.innerHTML = '✓ Готово! Переходим...';

    setTimeout(() => {
      closeModal();
      const backdrop = document.getElementById('metaOnboardBackdrop');
      let targetUrl = backdrop?.dataset?.redirect || '/dashboard.html';

      // Приклеиваем user_id к целевому переходу для бесшовной сессии на Safari
      if (createdUserId && !targetUrl.includes('user_id=')) {
        targetUrl += (targetUrl.includes('?') ? '&' : '?') + 'user_id=' + encodeURIComponent(createdUserId);
      }

      if (window.location.pathname.endsWith('dashboard.html') || window.location.pathname.endsWith('dashboard')) {
        updateDashboardUI(getUser());
      } else if (window.location.pathname.includes('day-')) {
        const m = window.location.pathname.match(/day-(\d)/);
        const dayNum = m ? parseInt(m[1], 10) : 1;
        if (typeof renderLessonQuiz === 'function') renderLessonQuiz(dayNum);
        if (typeof updateDayPageUI === 'function') updateDayPageUI();
      } else {
        window.location.href = targetUrl;
      }
    }, 200);
  }

  // Рендеринг списка приглашенных подруг на странице referral.html
  function renderInvitedFriendsUI() {
    const listEl = document.getElementById('invitedFriendsList');
    if (!listEl) return;

    const friends = getInvitedFriends();
    const count = getReferralCount();

    if (friends.length === 0 && count === 0) {
      listEl.innerHTML = `
        <div style="background: #FAF8F5; border: 1px dashed rgba(20, 18, 20, 0.12); border-radius: 12px; padding: 20px 14px; text-align: center;">
          <div style="font-size: 26px; margin-bottom: 6px;">💌</div>
          <div style="font-size: 13px; font-weight: 700; color: #141214; margin-bottom: 4px;">Пока нет приглашенных друзей</div>
          <div style="font-size: 11.5px; color: var(--text-muted); line-height: 1.45;">
            Поделитесь ссылкой на интенсив или персональным билетом на эфир. Как только ваш друг зарегистрируется, он сразу появится здесь, а вам откроются следующие дни!
          </div>
        </div>
      `;
      return;
    }

    // Если есть записи в локальном списке или счетчик > 0
    let itemsHTML = '';
    const displayFriends = friends.length > 0 ? friends : Array.from({ length: count }, (_, i) => ({
      name: `Друг #${i + 1}`,
      date: 'Сегодня',
      day: i === 0 ? 'День 2' : (i === 1 ? 'День 3' : 'День 4')
    }));

    displayFriends.forEach(f => {
      itemsHTML += `
        <div style="display: flex; align-items: center; justify-content: space-between; background: #FAF8F5; border: 1px solid rgba(20, 18, 20, 0.07); border-radius: 12px; padding: 10px 12px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <div style="width: 32px; height: 32px; border-radius: 50%; background: rgba(34, 169, 107, 0.12); color: #1A8754; font-size: 14px; display: flex; align-items: center; justify-content: center; font-weight: 700;">
              👥
            </div>
            <div>
              <div style="font-size: 12.5px; font-weight: 700; color: #141214;">${escapeHTML(f.name)}</div>
              <div style="font-size: 11px; color: var(--text-muted);">${f.day || 'Марафон'} • ${f.date || 'Недавно'}</div>
            </div>
          </div>
          <span style="font-size: 10.5px; font-weight: 700; color: #1A8754; background: rgba(34, 169, 107, 0.10); padding: 3px 8px; border-radius: 6px;">
            ✓ Учтено в реестре
          </span>
        </div>
      `;
    });

    listEl.innerHTML = itemsHTML;
  }

  // Обновление реферального интерфейса и разблокировки дней
  function updateReferralUI() {
    const count = getReferralCount();
    const refLink = getReferralLink();
    const shareUrl = getShareUrl();
    const unlockedDays = getUnlockedDays();

    // 1. Обновление текстовых полей ссылки на referral.html
    const refLinkEl = document.getElementById('refLinkText');
    if (refLinkEl) {
      refLinkEl.textContent = refLink;
    }

    // 2. Обновление кнопки "Пригласить подругу" (Telegram & VK Share)
    document.querySelectorAll('a[href*="t.me/share/url"], #dashboardShareBtn, a.btn-emerald[href*="share"]').forEach(el => {
      el.href = shareUrl;
      el.onclick = (e) => {
        e.preventDefault();
        shareInvite();
      };
    });

    // 3. Обновление счетчиков на dashboard.html
    const refCountVal = document.getElementById('refCountVal');
    if (refCountVal) {
      refCountVal.textContent = String(count);
    }

    // Рендерим список подруг на referral.html
    renderInvitedFriendsUI();

    // Счетчик "Открыто дней: X из 4"
    const openedDays = Math.min(4, unlockedDays.length);
    const openedDaysEl = document.querySelector('.stats-grid .stat-tile:nth-child(2) .stat-tile-value');
    if (openedDaysEl) {
      openedDaysEl.innerHTML = `${openedDays} <span style="font-size: 14px; font-weight: 600; color: #5C5857;">из 4</span>`;
    }

    // 4. Обновление прогресс-бара и бейджей
    const progressFill = document.querySelector('.progress-bar-fill');
    const percent = Math.min(100, Math.round((count / 3) * 100));
    if (progressFill) {
      progressFill.style.width = `${percent}%`;
    }

    // Бейджи на referral.html
    const refFriendsCountBadge = document.getElementById('refFriendsCountBadge');
    if (refFriendsCountBadge) {
      refFriendsCountBadge.textContent = `${count} из 3`;
    }
    const refDaysCountBadge = document.getElementById('refDaysCountBadge');
    if (refDaysCountBadge) {
      refDaysCountBadge.textContent = `${openedDays} из 4`;
    }

    // Бейдж на dashboard.html
    const dashboardCounterBadge = document.querySelector('.progress-card .counter-badge');
    if (dashboardCounterBadge) {
      dashboardCounterBadge.textContent = `${count} из 3 друзей`;
    }

    const progressText = document.querySelector('.progress-text');
    if (progressText) {
      progressText.textContent = `Шкала прогресса: ${count} из 3 друзей`;
    }

    // Виджет бонусного баланса (приветственный бонус 1 000 ₽ + 1 000 ₽ за каждого друга)
    updateBonusUI();

    // 5. Динамическая разблокировка карточек дней на dashboard.html
    const dayCards = document.querySelectorAll('.days-stack .day-item-card');
    if (dayCards.length >= 4) {
      [1, 2, 3, 4].forEach((dayNum, idx) => {
        const card = dayCards[idx];
        if (isDayUnlocked(dayNum)) {
          unlockDayCard(card, dayNum);
        } else {
          lockDayCard(card, dayNum);
        }
      });
    }

    // Статусы "✓ Пройдено" на dashboard.html
    [1, 2, 3, 4].forEach(d => {
      if (localStorage.getItem(`meta_day_${d}_completed`) === 'true') {
        const b = document.getElementById(`day${d}StatusBadge`);
        if (b) {
          b.className = 'badge-available';
          b.textContent = '✓ Пройдено';
          b.style.background = 'rgba(34, 169, 107, 0.18)';
        }
      }
    });

    // 6. Обновление страниц конкретных эфиров (day-2, day-3, day-4)
    updateDayPageUI();
  }

  window.openModal = openModal;
  window.openLeadModal = openModal;
  window.closeModal = closeModal;